export const PLACES = 'https://app.clickup.com/4661473/v/dc/4e871-2720/4e871-2761'
export const BENEFITS = 'https://app.clickup.com/4661473/v/dc/4e871-2720/4e871-2781'
export const PARTNERS = 'https://app.clickup.com/4661473/v/dc/4e871-2720/4e871-2801'
export const PROJECTS = 'https://app.clickup.com/4661473/v/dc/4e871-2720/4e871-1620'
